import script from "./EmployeeRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeRegister.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeRegister.vue?vue&type=style&index=0&id=3a927830&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a927830"]])

export default __exports__